import { Obj } from 'scrivito'
import { SchemaWidgetInstance } from '../SchemaWidgetClass'
import { bookJson } from './bookJsonLd'
import { collegeOrUniversityJson } from './collegeOrUniversityJsonLd'
import { contactPointJson } from './contactPointJsonLd'
import { creativeWorkJson } from './creativeWorkJsonLd'
import { educationalOccupationalProgramJson } from './educationalOccupationalProgramJsonLd'
import { educationalOrganizationJson } from './educationalOrganizationJsonLd'
import { eventJson } from './eventJsonLd'
import { jobPostingJson } from './jobPostingJsonLd'
import { personJson } from './personJsonLd'
import { postalAddressJson } from './postalAddressJsonLd'
import { productJson } from './productJsonLd'
import { reviewJson } from './reviewJsonLd'

function removeEmpty(obj: unknown): unknown {
  if (Array.isArray(obj)) {
    const filtered = obj.map(removeEmpty).filter((v) => v != null && v !== '')
    return filtered.length ? filtered : undefined
  }
  if (obj !== null && typeof obj === 'object') {
    const cleaned = Object.fromEntries(
      Object.entries(obj as Record<string, unknown>)
        .map(([k, v]) => [k, removeEmpty(v)])
        .filter(([, v]) => v != null && v !== '')
    )
    return Object.keys(cleaned).length ? cleaned : undefined
  }
  return obj
}

const schemas: { [key: string]: (schema: SchemaWidgetInstance, page: Obj | null) => object } = {
  Book: bookJson,
  CollegeOrUniversity: collegeOrUniversityJson,
  ContactPoint: contactPointJson,
  CreativeWork: creativeWorkJson,
  EducationalOccupationalProgram: educationalOccupationalProgramJson,
  EducationalOrganization: educationalOrganizationJson,
  Event: eventJson,
  JobPosting: jobPostingJson,
  Person: personJson,
  PostalAddress: postalAddressJson,
  Product: productJson,
  Review: reviewJson,
}

export const jsonLd: { [key: string]: (schema: SchemaWidgetInstance, page: Obj | null) => object } =
  Object.fromEntries(
    Object.entries(schemas).map(([key, fn]) => [
      key,
      (schema: SchemaWidgetInstance, page: Obj | null) =>
        removeEmpty(fn(schema, page)) as object,
    ])
  )
